module.exports = __webpack_public_path__ + "static/media/label-icon-white-icon-only.8cc023a9.png";